import { clientReducer } from './client/clientReducer';
import { adminsReducer } from './admins/adminsReducer';
import { cancellationReasonsReducer } from './cancellationReasons/cancelationsReasonsReducer';
import { orderPanelReducer } from './orders/ordersPanel/orderPanelReducer';
import { combineReducers } from "redux";
import { register } from "./register/registerReducer";
import { login } from "./login/loginReducer";
import { clientsReducer } from "./clients/clientsReducer";
import { filtersReducer } from "./filters/filtersReducer";
import { clientPanelReducer } from "./clients/panel/clientPanelReducer"
import { orderTypesReducer } from "./orderTypes/orderTypesReducer"
import { ordersReducer } from "./orders/ordersReducer"
import { validatorsReducer } from './validators/validatorsReducer';
import { vehiclesReducer } from "./vehicles/vehiclesReducer"
import { driversReducer } from "./drivers/driversReducer"
import { alertsReducer } from "./alerts/alertsReducer"
import { pricingReducer } from "./pricing/pricingReducer"
import { operatorsReducer } from "./operators/operatorsReducer"
import { usersReducer } from "./users/usersReducer"
import { unactiveusersReducer } from "./unactiveusers/unactiveusersReducer"
import { reportsReducer } from './reports/reportsReducer';
import { unactivepickuppointsReducer } from "./unactivepickuppoints/unactivepickuppointsReducer"
import { receptionPlacesReducer } from "./receptionPlaces/receptionPlacesReducer"
import { storeReducer } from './store/storeReducer';
import { storeDocsReducer } from './storeDocs/storeDocsReducer';
import { storeMapReducer } from './storeMap/storeMapReducer';
import { containersReducer } from './container/containersReducer';
import { validatorPanelReducer } from './validators/validatorsPanel/validatorPanelReducer';
import { detailedPriceReducer } from './detailedPrice/detailedPriceReducer';
import { notConfirmedUsersReducer } from './notConfirmedUsers/notConfirmedUsersReducer';

const rootReducer = combineReducers({
    register,
    login,
    clients: clientsReducer,
    clientPanel: clientPanelReducer,
    filtration: filtersReducer,
    orderTypes: orderTypesReducer,
    orders: ordersReducer,
    validators: validatorsReducer,
    validatorPanel: validatorPanelReducer,
    detailedPrice: detailedPriceReducer,
    orderPanel: orderPanelReducer,
    vehicles: vehiclesReducer,
    drivers: driversReducer,
    alerts: alertsReducer,
    pricing: pricingReducer,
    operators: operatorsReducer,
    cancellationReasons: cancellationReasonsReducer,
    client: clientReducer,
    admins: adminsReducer,
    users: usersReducer,
    unactiveusers: unactiveusersReducer,
    unactivepickuppoints: unactivepickuppointsReducer,
    receptionPlaces: receptionPlacesReducer,
    reports: reportsReducer,
    store: storeReducer,
    storeDocs: storeDocsReducer,
    containers: containersReducer,
    storeMap: storeMapReducer,
    notConfirmedUsers: notConfirmedUsersReducer
});

export default rootReducer;